import react from 'react';
import { MuiColorInput } from 'mui-color-input';

// Languages
import i18n from '../../i18n/i18n';

// Helpers
import { useTheme } from '../../hooks/useTheme';

// Components
import HeaderBar from '../../components/HeaderBar';
import ContentInfo from '../../components/ContentInfo';
import TitleContentInfo from '../../components/TitleContentInfo';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const AttendanceSheet: React.FC = () => {
    const theme = useTheme();

    const [color, setColor] = react.useState<string>('#000000');

    const handleChangeColor = (newColor: string) => {
        setColor(newColor);
    };

    return (
        <Box
            id="center"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary,
                width: '100%',
                height: '100vh',
                alignItems: 'center'
            }}
        >
            <HeaderBar />
            <Box sx={{ marginTop: '0.5em', width: '91vw' }}>
                <Box>
                    <TitleContentInfo title={i18n.t('AttendanceSheet.title')} />
                    <ContentInfo flexDirection="column">
                        <Box sx={{ width: '90%', padding: '0 1em' }}>
                            <Typography variant="body1" sx={{ marginBottom: '0.5em', color: theme.palette.text.primary }}>
                                {i18n.t('AttendanceSheet.color')}
                            </Typography>
                            <MuiColorInput format="hex" value={color} onChange={handleChangeColor} />
                        </Box>
                    </ContentInfo>
                </Box>
            </Box>
        </Box>
    );
};

export default AttendanceSheet;
